export default {
  mainPage: '主页',
  additionalInformationAdded: '添加的其他信息',
  assignOrSelectTheNameFromTheList: '从列表中分配或选择名称',
  AddPeopleToAnExistingList: '将人员添加到现有列表',
  updateList: '更新列表',
  eventModified: '事件已修改',
  completeTheRequiredFields: '完成所需字段',
  anErrorHasOcurred: '发生错误',
  insertKeybeUiOnYourWebsite: '在您的网站上插入Keybe UI',
  toInsertKeybeUiIntoYourWebsiteYouMustCreateADivElementWithTheIdKeybe: ' 要将KeybeUI插入到您的网站中，您必须在您的网站中创建一个ID为 "keybe "的DIV元素。',
  andThenAddTheFollowingScriptInTheFooterOfYourSite: '然后在你的网站的页脚添加以下脚本',
  toAddElementsInTheDOMToOpenTheKeybeUIYouCanUseAScriptSimilarToTheFollowing: '要在DOM中添加元素来打开KeybeUI，你可以使用类似下面的脚本。',
  selectProfilePhoto: '选择个人资料照片',
  selectPhoto: '选择照片',
  photoSuccessfullyUpdated: '照片成功更新',
  select: '选择'
}
